import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { space } from '@core-ds/primitives';
import Heading from './heading';

const Container = styled.nav`
   position: relative;
   margin-left: ${space[5]};
   color: white;
   text-align: left;
   width: auto;
`;

const List = styled.ul`
   display: flex;
   height: 100%;
   list-style: none;
   margin: 0;
   padding: 0;
`;

const Headings = ({ links, stores }) => {
   const [activeId, setActiveId] = useState(null);

   const headingOpened = useCallback(
      (openedId) => {
         setActiveId(activeId === openedId ? null : openedId);
      },
      [activeId, setActiveId]
   );

   return (
      <Container>
         <List>
            {links.map(
               (heading) =>
                  heading.disabled || (
                     <Heading
                        key={`${heading.title}-heading`}
                        info={heading}
                        isActive={activeId === heading.title}
                        headingOpened={headingOpened}
                        stores={stores}
                     />
                  )
            )}
         </List>
      </Container>
   );
};

export default Headings;
